<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Usuarios',
        buttons: [{ text: 'Nuevo Usuario', action: openModal }],
        headers: ['ID', 'Nombre', 'Usuario', 'Correo', 'Estado', 'Opciones'],
        visibleColumnsMobile: [0, 1, 4,5],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <Modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :title="'Nueva Usuario'"
      :fields="formFields"
      :submitButtonText="'Guardar usuario'"
      @close="closeModal"
      v-model="formData"
      @submit="NewUser"
    />

    <ModalUpdateComp
      v-if="isModalUpdate"
      :title="'Actualizar Permisos'"
      :isOpen="isModalUpdate"
      :selectedData="selectedRow"
      :formFields="formFieldsPermisos"
      @updateData="updatePermisos"
      @close="closeModal"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @confirm = "updateEstado()"
      @close="closeDelete"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import Modal from "@/components/ModalComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import ModalUpdateComp from "@/components/ModalUpdateComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    Modal,
    DeleteComp,
    ModalUpdateComp,
    SpinnerComp,
  },
  data() {
    return {
      loading: false,
      idUser:null,
      isModalOpen: false,
      isDeleteOpen: false,
      isModalUpdate: false,
      selectedRow:[],
      sendForm:false,
      rows: [],
      formFields: [
        { label: "Nombre:", model: "nombre", placeholder: "Ingrese el nombre" },
        {
          label: "Usuario",
          model: "usuario",
          placeholder: "Ingrese el usuario",
        },
        { label: "Correo", model: "correo", placeholder: "Ingrese el correo" },
        {
          label: "Estado",
          model: "estado",
          type: "select",
          options: [
            { label: "Activo", value: 1 },
            { label: "Inactivo", value: 0 },
          ],
        },
        {
          label: "Contraseña",
          type: "password",
          model: "clave",
          placeholder: "Ingrese su contraseña",
        },
      ],
      options: [
        {
          icon: "material-symbols-outlined key",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined person_off",
          action: "disable",
          color: "bg-red-500",
        },
      ],
      formFieldsPermisos: [
        { label: "Cotizaciones", model:1, type: "toggle" },
        { label: "Ordenes de Compra", model:2, type: "toggle" },
        { label: "Productos", model:3, type: "toggle" },
        { label: "Clientes", model:4, type: "toggle" },
        { label: "Proveedores", model:5, type: "toggle" },
        { label: "Información", model:6, type: "toggle" },
        { label: "Usuarios", model:7, type: "toggle" },
        { label: "Facturas Cliente", model:8, type: "toggle" },
        { label: "Facturas Proveedores", model:9, type: "toggle" },
      ],
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.isModalUpdate = false;
      this.idUser = null;
    },

    closeDelete() {
      this.isDeleteOpen = false;
    },

    handleOptionAction(action, row) {
      const actions = {
        edit: () => {
          this.idUser = row.id;
          this.getPermisos(row.id);
        },
        disable: () => {
          this.deleteMessage = `¿Estás seguro de que deseas cambair el estado de: ${row.nombre}?`;
          this.idUser = row.id;
          this.isDeleteOpen = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },

    updatePermisos(permisos){
      this.$axios.put(`/updatePerm/${this.idUser}`,{
        permisos: permisos
      }).then(response => {
        alert(response.data.message);
      }).finally(this.closeModal);
    },

    updateEstado(){
      this.$axios.put(`/updateEst/${this.idUser}`).then(response =>{
        alert(response.data.message);
        this.getData();
      }).catch(error => {
        alert(error.response.data.message);
      }).finally(this.closeDelete());
    },

    getData() {
      this.loading = true;
      this.$axios
        .get("/getUser")
        .then((response) => {
          this.rows = response.data.map((item) => ({
            id: item.id,
            nombre: item.nombre,
            usuario: item.usuario,
            correo: item.correo,
            estado: item.estado === 1 ? "Activo" : "Inactivo",
          }));
        })
        .catch((error) => {
          alert(error.response?.data?.message || "Error al obtener datos.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    NewUser(formData) {
      if(this.sendForm){
        return;
      }
      this.sendForm = true;
      formData.estado = formData.estado === 1;
      this.$axios
        .post("/register", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() =>{
          this.sendForm = false;
        });
    },

    getPermisos(id){
      this.$axios.get(`/permisos/${id}`).then(response => {
        this.selectedRow = response.data.permisos;
      }).finally(this.isModalUpdate = true);
    }
  },
  mounted() {
    this.getData();
  },
};
</script>
